import styled from 'styled-components';
import { Grid } from '@interstate/components/Grid';

export const FooterGrid = styled(Grid)`
    padding: 20px 32px 32px;
`;
